<template>
  <div class="module-king img-cover" :style="aStyle">
    <div class="update-time" :style="timeStyle">
      最新数据更新于 {{ updatedTime | formatTime }}
      <div class="tips">注：可刷新页面查看最新排行</div>
    </div>
    <div
      class="top-lists"
      :class="{ border: viewStatus != 2 }"
      :style="kingStyle"
    >
      <template v-if="topList.length > 0">
        <ul v-for="(item, index) in topList" :key="index" class="top-item">
          <li :style="itemStyle">
            <span :style="numStyle">{{ index + 1 }}</span>
          </li>
          <li :style="itemStyle">{{ item.role_name }}</li>
          <li :style="itemStyle">{{ item.amount }}</li>
        </ul>
      </template>
      <template v-else>
        <span class="empty">暂无数据</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'McKing',
  props: {
    imageValue: {
      type: Object,
      default: () => {}
    },
    time: {
      type: Object,
      default: () => {}
    },
    king: {
      type: Object,
      default: () => {}
    },
    item: {
      type: Object,
      default: () => {}
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },

  computed: {
    aStyle() {
      return {
        height: this.$unit(this.bgHeight),
        backgroundImage: `url(${
          this.imageValue.imagePath || this.defaultImage
        })`
      };
    },
    timeStyle() {
      return {
        fontSize: `${this.$unit(this.time.fontSize)}`,
        color: `${this.time.fontColor}`,
        top: `${this.$unit(this.time.top)}`,
        left: `${this.$unit(this.time.left)}`
      };
    },
    kingStyle() {
      return {
        width: `${this.$unit(this.king.width)}`,
        height: `${this.$unit(this.king.height)}`,
        top: `${this.$unit(this.king.top)}`,
        left: `${this.$unit(this.king.left)}`
      };
    },
    itemStyle() {
      return {
        fontSize: `${this.$unit(this.item.fontSize)}`,
        color: `${this.item.fontColor}`,
        height: `${this.$unit(this.item.height)}`,
        lineHeight: `${this.$unit(this.item.height)}`
      };
    },
    numStyle() {
      return {
        fontSize: `${this.$unit(this.item.numfontSize)}`,
        color: `${this.item.numfontColor}`,
        backgroundColor: `${this.item.numbgColor}`
      };
    }
  },

  data() {
    return {
      defaultImage:
        'https://cdn-tx-admin-test.3kwan.com/2023/08/29/2f064b19ab000a226202aa468c71a8a5.jpeg',
      bgHeight: 1500,
      topList: [],
      updatedTime: 0
    };
  },
  watch: {
    imageValue() {
      this.init();
    }
  },
  mounted() {
    this.init();
    if (this.viewStatus == 2) {
      this.getKing();
    } else {
      this.getTestKing();
    }
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.bgHeight = h;
      };
      img.src = this.imageValue.imagePath;
    },
    async getKing() {
      let { code, data } = await this.$api.user.getPayKing();
      if (code !== 0) return;
      this.topList = data.roles;
      this.updatedTime = data.updatedTime;
    },
    getTestKing() {
      let origin = {
        updated_time: 1692892800,
        roles: [
          { server_name: '外测1服', role_name: '范尼赫迈亚', amount: 354 },
          { server_name: '外测1服', role_name: '范尼赫迈亚', amount: 354 }
        ]
      };
      this.topList = origin.roles;
      this.updatedTime = origin.updatedTime;
    }
  },
  filters: {
    formatTime: function (num = new Date().getTime()) {
      let format = 'YYYY-mm-dd HH:MM';
      let ret, date, renum;
      // 处理时间戳，js一般获取的时间戳是13位，PHP一般是10位,根据实际情况做判断处理
      if (num.toString().length == 10) {
        date = new Date(parseInt(num) * 1000);
      } else {
        date = new Date(parseInt(num));
      }
      const opt = {
        Y: date.getFullYear().toString(), // 年
        m: (date.getMonth() + 1).toString(), // 月
        d: date.getDate().toString(), // 日
        H: date.getHours().toString(), // 时
        M: date.getMinutes().toString(), // 分
        S: date.getSeconds().toString() // 秒
        // 目前用的是这六种符号,有其他格式化字符需求可以继续添加，值必须转化成字符串
      };
      for (var k in opt) {
        ret = new RegExp('(' + k + '+)').exec(format);
        if (ret) {
          renum =
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'); //根据复数前面是否补零,如“mm”补零，单“m”前面不补零
          format = format.replace(ret[1], renum); //替换
        }
      }
      return format;
    }
  }
};
</script>

<style lang="scss" scoped>
.border {
  border: 1px solid #000;
}
.img-cover {
  background-repeat: no-repeat;
  background-size: cover;
}
.module-king {
  position: relative;
  .update-time {
    position: absolute;
    left: 50%;
    top: 200px;
    color: #ffdb85;
    font-size: 0.2rem;
    height: 38px;
    line-height: 38px;
    width: 100%;
    text-align: center;
    transform: translateX(-50%);
    .tips {
      margin-top: 10px;
    }
  }
  .top-lists {
    position: absolute;
    overflow-y: scroll;
    .top-item {
      display: flex;
      justify-content: center;
      align-items: center;
      li {
        flex: 0 0 28%;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        &:nth-child(1) {
          flex: 0 0 24%;
        }
        &:nth-child(2) {
          flex: 0 0 37%;
          margin-left: 7%;
        }
        &:nth-child(3) {
          flex: 0 0 32%;
          margin-left: 3%;
        }
        span {
          display: inline-block;
          width: 40px;
          height: 40px;
          line-height: 45px;
          color: #a53936;
          font-size: 0.26rem;
          background: #ffeaa8;
          border-radius: 50%;
        }
      }
    }
  }
}
.empty {
  text-align: center;
  font-size: 26px;
  color: #000;
  width: 100%;
  display: block;
  margin-top: 20px;
}
</style>
